import moment from 'moment';

class ShoppingCartService {

	getDisplayTicketBySeatIdentifier(shoppingCart, seatIdentifier, eventStorageId) {
		/*
		* We need to filter for the eventId here because the seatIdentifier is NOT UNIQUE across multiple events
		* (Same Seatingplan can be used for multiple events) and now we can have tickets of different events in one shoppingcart.
		*/
		const displayTicket = (shoppingCart.events || [])
			.filter(scEvent => scEvent.eventId === eventStorageId)
			.flatMap(scEvent => scEvent.displayTickets)
			.find(dt => dt.seatIdentifier === seatIdentifier);
		return displayTicket;
	}

	getVisualBulkDisplayTicketsBySeatIdentifier(shoppingCart, seatIdentifier, eventStorageId) {
		const displayTickets = (shoppingCart.events || [])
			.filter(scEvent => scEvent.eventId === eventStorageId)
			.flatMap(scEvent => scEvent.displayTickets)
			.filter(dt => dt.seatIdentifier === seatIdentifier);
		return displayTickets;
	}

	getTicketItemUuidsToDelete(shoppingCart, priceLevelUuid, amount) {
		const displayTicket = this.findDisplayTktByPriceLvlUuid(shoppingCart, priceLevelUuid);
		if (!displayTicket || !displayTicket.ticketItemUuids) {
			return [];
		}
		const ticketItemUuids = displayTicket.ticketItemUuids.slice(0, amount);
		return ticketItemUuids;
	}

	getTicketDifference(shoppingCart, priceLevelUuid, amount) {
		const displayTicket = this.findDisplayTktByPriceLvlUuid(shoppingCart, priceLevelUuid);
		if (!displayTicket) {
			return amount;
		}
		return (amount - displayTicket.numberOfSeats);
	}

	findDisplayTktByPriceLvlUuid(shoppingCart, priceLevelUuid) {
		const displayTicket = (shoppingCart.events || [])
			.flatMap(scEvent => scEvent.displayTickets)
			.find(dt => dt.priceLevelUuid === priceLevelUuid);
		return displayTicket;
	}

	getMinEventBegin(shoppingCart) {
		const minEventBegin = shoppingCart.events.length < 1 ? '' : shoppingCart.events
		.map(scEvent => scEvent.eventBegin)
		.reduce((a, b) => (moment(a) < moment(b) ? a : b));
		return minEventBegin;
	}
}

const shoppingCartService = new ShoppingCartService();
export default shoppingCartService;
